import BaseApi from '../BaseApi';
import { StatisticApiConverter } from './StatisticApiConverter';

class StatisticApi extends BaseApi {
  converter;

  constructor(baseUrl) {
    super(baseUrl);
    this.baseUrl = `${baseUrl}/api/mini_admin/statistic`;
    this.converter = new StatisticApiConverter();
  }

  getStatistic = (formData) =>
    this.sendQuery(
      this.queryTypes.GET,
      `${this.baseUrl}`,
      formData,
      undefined,
      this.converter.convertStatistic,
    );
}

export default StatisticApi;
